export class SearchableAccountV2Model {
    accountId;
    esIndexPrefix;
    name;
    requestingAccount;
    type;
}
//# sourceMappingURL=searchable-account-v2.js.map